import React from 'react';
import { LOADING_STATE } from '../util/loading';
import useRDBUserInfo from './useRDBUserInfo';
import { useFirebase } from '../services/firebase';
import { courierFcm } from '../api/cloudFunctions';
import { getFunctions } from 'firebase/functions';
import { getVersion } from '../util/app';
import { getDeviceV2 } from '../util/device';

function useFCMTokenSync(fcmToken?: string, err?: string) {
  const { userInfo, currentUser, loadingState } = useRDBUserInfo();
  const { app, isImpersonatingUser } = useFirebase();
  React.useEffect(() => {
    const isLoading = loadingState !== LOADING_STATE.LOADED;
    if (isLoading || !currentUser || !fcmToken || !app || isImpersonatingUser) {
      return;
    }

    console.log(`FCM Token, ${fcmToken}`);

    async function syncCourier(userId: string, token: string) {
      try {
        const fns = getFunctions(app);
        const appVersion = await getVersion();
        const platform = getDeviceV2();
        courierFcm(fns, { userId, token, appId: appVersion, platform });
      } catch (e) {
        console.error('Error syncing FCM token with Courier:', e);
      }
    }

    syncCourier(currentUser.uid, fcmToken);
  }, [userInfo, currentUser, fcmToken, loadingState, app, isImpersonatingUser]);
}

export default useFCMTokenSync;
